import styled from "styled-components";
import { colorPalette } from "../../../config";

export const Container = styled.div`
    width : 100vw;
    height: 100vh;
    position : fixed;
    top : 0;
    left : 0;
    display : flex;
    align-items : center;
    justify-content : center;
    background-color : rgba(0, 0, 0, 0.7);
    z-index : 99999999;
`

export const ModalUp = styled.div`
    min-width : 100px;
    min-height; 100px;
    background-color : ${colorPalette.white};
    border-radius : 1.5rem;
    max-width: 90vw;
    flex-wrap: nowrap;
    max-height: 100vh;
    overflow-y: auto;
    clip-path: inset(0 round 1.5rem);

    ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
    }

    ::-webkit-scrollbar-track {
        background-color: transparent;
    }

    ::-webkit-scrollbar-track-piece {
        background-color: #eee;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 8px;
        background-color: #ccc;
    }

    ::-webkit-scrollbar-button {
        display: none;
    }
`
export const ModalImg = styled.img`
    width : 100%;
`

export const ModalImgUp = styled.img`
    width : 49.8%;
    margin: 0 0.1% 0 0.1%;
`

export const TopWrapper = styled.div`
    padding : 1rem;
    width : fit-content;
    cursor: pointer;
    margin : auto 0px auto auto;
`

export const BottomWrapper = styled.div`
    padding : 1rem;
    width : fit-content;
    cursor: pointer;
    margin : auto 0px auto auto;
`